import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Strings from "../utils/Strings.constants";
import { Heading } from "./ui/Heading";
import { faClock, faDollarSign } from "@fortawesome/pro-solid-svg-icons";
import { cn } from "../utils";
import TwoIcon from "@/shared/media/icons/two.svg";

interface PreventiveCareHeaderProps {
    wrapperClass?: string;
    iconWrapperClass?: string;
    subheaderClass?: string;
    showNumbered?: boolean;
    header?: string;
    subheader?: string;
    /**
     * Breakpoint from which the "Next-day coverage" / "No deductible" chips move up beside the
     * heading. `md` is the standing behaviour; ENG-18988's compare-table variants hold them under
     * the subheader until `lg` (brief D6).
     */
    inlineChipsFrom?: "md" | "lg";
}

export default function PreventiveCareHeader(props: PreventiveCareHeaderProps) {
    const { wrapperClass, iconWrapperClass, subheaderClass, showNumbered, header, subheader, inlineChipsFrom = "md" } = props;
    const inlineChipsClass = inlineChipsFrom === "lg" ? "lg:flex" : "md:flex";
    const stackedChipsClass = inlineChipsFrom === "lg" ? "lg:hidden" : "md:hidden";
    return (
        <div className={cn("flex flex-col gap-2 text-center", wrapperClass, showNumbered && "text-left")}>
            <div className={cn(showNumbered && "flex items-center gap-2")}>
                {showNumbered && <TwoIcon data-testid="two-icon-numbered" className="size-6 lg:size-8" />}
                <Heading level="h2" className={cn("text-lg font-bold", showNumbered && "text-base leading-5 lg:text-lg lg:leading-7")}>
                    {header ?? (showNumbered ? Strings.PREVENTIVE_CARE_HEADER : Strings.PTZ_CA.PREVENTIVE_CARE_HEADER)}
                </Heading>
                {showNumbered && (
                    <div className={cn("ml-auto hidden flex-row gap-2", inlineChipsClass)}>
                        <div className="flex items-center gap-1">
                            <FontAwesomeIcon icon={faClock} size="lg" className="text-content-brand-b" />
                            <span className={cn("text-xs font-bold text-content-primary", showNumbered && "lg:text-base")}>Next-day coverage</span>
                        </div>
                        <div className="flex items-center gap-1">
                            <FontAwesomeIcon icon={faDollarSign} size="lg" className="text-content-brand-b" />
                            <span className={cn("text-xs font-bold text-content-primary", showNumbered && "lg:text-base")}>No deductible</span>
                        </div>
                    </div>
                )}
            </div>
            <div className={cn("flex flex-col gap-2 xl:gap-3")}>
                <p className={cn("text-sm text-content-secondary", subheaderClass, showNumbered && "-mt-2 pl-8 lg:text-base")}>
                    {subheader ?? (showNumbered ? Strings.PREVENTIVE_CARE_SUBHEADER : Strings.PTZ_CA.PREVENTIVE_CARE_SUBHEADER)}
                </p>
                <div className={cn("flex justify-center gap-2", iconWrapperClass, showNumbered && cn("justify-start pl-8", stackedChipsClass))}>
                    <div className="flex items-center gap-1">
                        <FontAwesomeIcon icon={faClock} size="lg" className="text-content-brand-b" />
                        <span className="text-xs font-bold text-content-primary">Next-day coverage</span>
                    </div>
                    <div className="flex items-center gap-1">
                        <FontAwesomeIcon icon={faDollarSign} size="lg" className="text-content-brand-b" />
                        <span className="text-xs font-bold text-content-primary">No deductible</span>
                    </div>
                </div>
            </div>
        </div>
    );
}
